import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Notification Center Service Stores (Slice 1)
 *
 * Backed by the API services in `system/notifications/` and
 * `system/notification-reads/`. Both stores cache locally so the
 * notification bell / inbox can render instantly from MobX state and
 * patch read/dismissed status optimistically.
 *
 * Frontend name -> store mapping:
 *   'notifications'      -> notificationsStore
 *   'notification-reads' -> notificationReadsStore
 */
export const notificationStores: ServiceStoreConfig[] = [
  {
    name: "notifications",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },
  {
    name: "notification-reads",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },
];
